<template>
  <v-row
      dense
  >
    <v-col
        v-for="(item, idx) in items"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        :key="idx"
    >
      <slot
          :item="item"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
    name: 'GhShopList',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped>

</style>
